module.exports = __webpack_public_path__ + "static/media/gts31.95a01ae9.png";